import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, Subject, throwError } from "rxjs";
import { map, catchError, finalize } from "rxjs/operators";

@Injectable()
export class PendingRequestInterceptor implements HttpInterceptor {
    private _pendingRequests: number = 0;
    private _pendingRequestsStatus: Subject<boolean> = new Subject<boolean>();

    private _pendingTimerRequests: number = 0;
    private _pendingTimerRequestsStatus: Subject<boolean> = new Subject<boolean>();

    private exceptionList: string[] = [];
    private timerList: string[] = [];

    get pendingRequestsStatus(): Observable<boolean> {
        return this._pendingRequestsStatus.asObservable();
    }

    get pendingTimerRequestsStatus(): Observable<boolean> {
        return this._pendingTimerRequestsStatus.asObservable();
    }

    get pendingRequests(): number {
        return this._pendingRequests;
    }

    pendingRequestsStatusSet(): void {
        this._pendingRequests++;
        this._pendingRequestsStatus.next(true);
    }

    pendingRequestsStatusRemove(): void {
        this._pendingRequests--;
        this._pendingRequestsStatus.next(false);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // do not show loader for exception list
        let show = true;
        let isTimerRequest = false;

        for (const i in this.exceptionList) {
            if (req.url.indexOf(this.exceptionList[i]) > -1) {
                show = false;
                break;
            }
        }

        for (const i in this.timerList) {
            if (req.url === this.timerList[i] || req.url.includes(this.timerList[i])) {
                isTimerRequest = true;
                break;
            }
        }

        if (show) {
            this._pendingRequests++;
        }

        if (this._pendingRequests >= 1) {
            this._pendingRequestsStatus.next(true);
        }

        if (isTimerRequest) {
            this._pendingTimerRequests++;
        }

        if (this._pendingTimerRequests >= 1) {
            this._pendingTimerRequestsStatus.next(true);
        }

        return next.handle(req).pipe(
            map((event) => {
                return event;
            }),
            catchError((err) => {
                return throwError(() => err);
            }),
            finalize(() => {
                if (show) {
                    this._pendingRequests--;
                }

                if (this._pendingRequests === 0) {
                    this._pendingRequestsStatus.next(false);
                }

                if (isTimerRequest) {
                    this._pendingTimerRequests--;
                }

                if (this._pendingTimerRequests === 0) {
                    this._pendingTimerRequestsStatus.next(false);
                }
            }),
        );
    }
}
